<template>
	<div class="c-text-editor">
		<!-- <bubble-menu
			class="bubble-menu"
			:tippy-options="{ duration: 100 }"
			:editor="editor"
			v-if="editor"
		>
			<span class="text-selection">
				{{ selectionMath }}
			</span>
			<span class="text-selection">
				{{ selectionCount }}
			</span>
		</bubble-menu> -->
		<editor-content :editor="editor" />
	</div>
</template>

<script>
import { Editor, EditorContent, BubbleMenu, Extension } from '@tiptap/vue-2';
import Document from '@tiptap/extension-document';
import Paragraph from '@tiptap/extension-paragraph';
import Text from '@tiptap/extension-text';
import HorizontalRule from '@tiptap/extension-horizontal-rule';
import Bold from '@tiptap/extension-bold';
import HardBreak from '@tiptap/extension-hard-break';
import KeyHandler from '@/lib/tiptap/key-handler.js';
import History from '@tiptap/extension-history';
import { SmilieReplacer } from '@/lib/tiptap/replacer.js';
import { TextReplacer } from '@/lib/tiptap/text-replacer.js';
import BlankLines from '@/lib/tiptap/blank-lines.js';
import PasteParser from '@/lib/tiptap/paste-parser.js';
import debounce from '@/lib/debounce.js';
import Placeholder from '@tiptap/extension-placeholder';
import Image from '@tiptap/extension-image';

// Not using this atm but may use it in the future
//import { evaluate } from 'mathjs';

export default {
	components: {
		EditorContent,
		//BubbleMenu,
	},

	data: function () {
		return {
			updated: false,
			editor: null,
		};
	},

	watch: {
		block: function () {
			if (this.block.content && this.block.content.html) {
				if (!this.updated) {
					this.editor.commands.setContent(this.block.content.html);
				} else {
					this.updated = false;
				}
			}
		},
		focusTrigger: function () {
			if (this.focusId && this.focusId === this.block._id) {
				this.editor.commands.focus();
			}
		},
	},

	computed: {
		focusTrigger: function () {
			return this.$store.getters['dashboard/focusTrigger'];
		},
		focusId: function () {
			return this.$store.getters['dashboard/focusId'];
		},
		// selectionCount: function () {
		// 	if (this.selection) {
		// 		return this.selection.length + ' chars';
		// 	} else {
		// 		return '';
		// 	}
		// },
		// selectionMath: function () {
		// 	if (this.selection && this.selection.length > 3) {
		// 		let res = '';
		// 		try {
		// 			res = evaluate(this.selection);
		// 		} catch (err) {}
		// 		if (res) {
		// 			res = '= ' + res;
		// 		}
		// 		return res;
		// 	} else {
		// 		return '';
		// 	}
		// },
		// selection: function () {
		// 	if (!this.editor) {
		// 		return;
		// 	}
		// 	let { state } = this.editor;
		// 	let selection = state.selection;
		// 	if (!selection) {
		// 		return;
		// 	}
		// 	const { from, to } = selection;
		// 	const text = state.doc.textBetween(from, to, ' ');
		// 	return text;
		// },
	},

	props: {
		block: {
			type: Object,
		},
		fakeBlock: {
			type: Boolean,
			default: false,
		},
	},

	methods: {
		onUpdate: function () {
			let content = this.editor.getHTML();
			if (this.fakeBlock) {
				// create block
				this.$emit('createBlock', content);
				return;
			}
			let block = JSON.parse(JSON.stringify(this.block));
			block.content.html = content;
			this.updated = true;
			this.$emit('update', block);
		},
	},

	mounted: function () {
		let self = this;
		this.editor = new Editor({
			//enablePasteRules: true,
			onFocus({ editor, event }) {
				self.$emit('focus', true);
			},
			onBlur({ editor, event }) {
				self.$emit('focus', false);
			},
			parseOptions: {
				preserveWhitespace: 'full',
			},
			onUpdate: function () {
				onUpdate();
			},
			editorProps: {
				handlePaste: PasteParser,
				//clipboardTextParser: BlankLines,
				handleDOMEvents: {
					drop: (view, e) => {
						//e.preventDefault();
					},
				},
			},
			content: '',
			extensions: [
				// new (class extends Extension {
				// 	keys() {
				// 		console.log('plz work');
				// 		return {
				// 			'Shift-Enter'() {
				// 				console.log('break');
				// 				return true;
				// 			},
				// 		};
				// 	}
				// })(),
				Document,
				Paragraph,
				Text,
				Bold,
				//HorizontalRule,
				Image,
				SmilieReplacer,
				TextReplacer,
				Placeholder.configure({
					placeholder: 'Start typing..',
				}),
				KeyHandler.configure({
					isFake: this.fakeBlock,
					blockId: this.block._id,
				}),
				HardBreak,
				// History.configure({
				// 	depth: 10,
				// 	newGroupDelay: 200,
				// }),
			],
		});

		if (this.block.content && this.block.content.html) {
			this.editor.commands.setContent(this.block.content.html);
		}
		let onUpdate = debounce(this.onUpdate, 200);
		this.editor.on('update', onUpdate);
	},
	beforeDestroy() {
		this.editor.destroy();
	},
};
</script>

<style lang="scss">
.c-text-editor {
	.bubble-menu {
		display: flex;
		background-color: var(--g1);
		padding: var(--margin) 0;
		border-radius: var(--border-radius-sm);

		button {
			border: none;
			background: none;
			color: #fff;
			font-size: 0.85rem;
			font-weight: 500;
			padding: 0 0.2rem;
			opacity: 0.6;

			&:hover,
			&.is-active {
				opacity: 1;
			}
		}
	}

	.text-selection {
		display: inline-block;
		padding: 0 var(--margin);
		font-size: var(--font-size-sm);

		&:last-child {
			border-left: rgba(255, 255, 255, 0.2) solid 1px;
		}
	}

	.ProseMirror {
		font-size: var(--font-size);
		line-height: 24px;
		caret-color: var(--p3);

		font-feature-settings: 'case' 0, 'cpsp' 0, 'dlig' 0, 'frac' 0, 'dnom' 0,
			'numr' 0, 'salt' 0, 'subs' 0, 'sups' 0, 'tnum' 0, 'zero' 0, 'ss01' 0,
			'ss02' 0, 'ss03' 0, 'ss04' 0, 'cv01' 0, 'cv02', 'cv03', 'cv04', 'cv05',
			'cv06', 'cv07' 0, 'cv08', 'cv09', 'cv10', 'cv11' 0, 'calt', 'ccmp', 'kern';

		&-focused {
			p.is-editor-empty:first-child::before {
				content: attr(data-placeholder);
				float: left;
				color: #ced4da;
				pointer-events: none;
				height: 0;
				opacity: 0.5;
			}
		}

		p {
			margin-bottom: 0;
		}

		.decoration-color {
			display: inline-block;
			width: 12px;
			height: 12px;
			margin-right: var(--margin-sm);
			background-color: var(--color);
			//font-family: var(--font-family-monospace);
			border: black solid 1px;
			border-radius: var(--border-radius-sm);
		}

		.decoration-email {
			display: inline-block;
			width: 14px;
			height: 14px;
			margin-right: var(--margin);
			background-color: var(--color);
			background-position: center center;
			background-size: contain;
			background-repeat: no-repeat;
			border-radius: 20px;
			background-color: #fff;
			transition: box-shadow var(--transition-time-sm) linear;

			&:hover,
			&:active {
				box-shadow: 0 0 0 2px var(--p3);
			}

			&:focus {
				outline: none;
			}
		}

		&:focus {
			outline: none;
		}

		.p-bold,
		strong,
		bold {
			font-weight: 700;
			letter-spacing: 0.2px;
		}

		hr {
			margin: 0;
			padding: 10px 0;
			&:after {
				content: '';
				position: absolute;
				top: calc(50% - 1px);
				left: 0;
				width: 100%;
				height: 2px;
				background-color: var(--g1);
				opacity: 0.8;
				border-radius: 2px;
			}

			&.ProseMirror-selectednode {
				background-color: rgba(var(--p-r), var(--p-g), var(--p-b), 0.8);
			}
		}

		img {
			width: 100%;
			height: auto;
		}
	}
}
</style>